<script>
    import { onMount } from 'svelte';
    onMount(() => {
        window.scrollTo(0, 0);
    });
    import "./footer.css";
    const logUrl = "./images/logo.svg";
    const facebookUrl = "./images/ic_facebook.svg";
    const twitterUrl = "./images/ic_twitter.svg";
    const linkedinUrl = "./images/ic_linkedin.svg";
    const instagramUrl = "./images/ic_instagram.svg";
    const telegramUrl = "./images/ic_telegram.svg";

    const options = [
        {
            title: 'Quick Links',
            items: [
                {
                    label: 'Home',
                    url: "/"
                },
                {
                    label: 'Explore Projects',
                    url: "#/explore-projects?status=Live&blockchain=All"
                }
            ]
        },
        {
            title: 'Information',
            items: [
                {
                    label: 'Privacy Policy',
                    url: `#/privacy-policy`
                },
                {
                    label: 'Terms of Use',
                    url: `#/terms-conditions`
                }
            ]
        },
        {
            title: 'Support',
            items: [
                {
                    label: 'Help Center',
                    url: `#/help-center`
                }
            ]
        }
    ]
</script>
<footer class="details-footer">
    <div class="container">
        <div class="footer-content">
            <div class="col">
                <div class="footer-text">
                    <a href="/">
                        <img class="footer-logo" src={logUrl} alt="">
                    </a>
                    <p>
                        Polinate is a next generation crowdfunding platform designed to discover, launch, and empower creatives globally in a permissionless way.
                    </p>
                    <div class="footer-socials">
                        <a href="https://www.facebook.com/polinate.io">
                            <img src={facebookUrl} alt="" />
                        </a>
                        <a href="https://twitter.com/polinate_io">
                            <img src={twitterUrl} alt="" />
                        </a>
                        <a href="https://www.linkedin.com/company/polinate">
                            <img src={linkedinUrl} alt="" />
                        </a>
                        <a href="https://www.instagram.com/polinate.io">
                            <img src={instagramUrl} alt="" />
                        </a>
                        <a href="https://t.me/polinate">
                            <img src={telegramUrl} alt="" />
                        </a>
                    </div>
                </div>
            </div>
            {#each options as item}
                <div class="col">
                    <div class="footer-links-wrapper">
                        <h2>{item.title}</h2>
                        <ul>
                            {#each item.items as child}
                                <li>
                                    <a href={child.url}>{child.label}</a>
                                </li>
                            {/each}
                        </ul>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</footer>
<footer id="footer">
    <p>
        Copyright @ 2021, All Rights Reserved
    </p>
</footer>
